export default __webpack_public_path__ + "static/media/pfh-logo.915daa2e.svg";